import React from 'react';
import { TextBox } from 'devextreme-react/text-box';
import { GetDateTimeStandardFormat } from "../../common/Utils";

const TransactionOverview = ({ transaction, profile, ABECASUSER_LOGIN_TYPE, itemcode, lotcode, selectedTotals }) => {
  const columns = [
    <div className="col-md-3" key="transaction-number">
      <TextBox
        disabled={true}
        label="Transaction #:"
        value={transaction.transactionnumber}
        stylingMode="outlined"
        labelMode="static"
      />
    </div>,

    (itemcode && lotcode) && (
      <div className="col-md-3" key="item-code">
        <TextBox
          disabled={true}
          label="Item Code"
          name="transaction-item-code"
          value={itemcode}
          stylingMode='outlined'
          labelMode="static"
        />
      </div>
    ),

    (itemcode && lotcode) && (
      <div className="col-md-3" key="lot-code">
        <TextBox
          disabled={true}
          label="Lot Code"
          name="transaction-lot-code"
          value={lotcode}
          stylingMode='outlined'
          labelMode="static"
        />
      </div>
    ),

    profile.hasOwnProperty("LOGINTYPEID") && profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE && (
      <div className="col-md-3" key="customer">
        <TextBox
          disabled={true}
          label="Customer:"
          value={transaction.rCustomerNavigation?.identityid}
          stylingMode="outlined"
          labelMode="static"
        />
      </div>
    ),

    <div className="col-md-3" key="shipper-id">
      <TextBox
        disabled={true}
        label="Shipper ID:"
        value={transaction.rShipperNavigation?.identityid}
        stylingMode="outlined"
        labelMode="static"
      />
    </div>,

    transaction.transactiontype === "S" && (
      <div className="col-md-3" key="consignee-name">
        <TextBox
          disabled={true}
          label="Consignee Name:"
          value={transaction.rConsigneeNavigation?.name}
          stylingMode="outlined"
          labelMode="static"
        />
      </div>
    ),

    <div className="col-md-3" key="po-no">
      <TextBox
        disabled={true}
        label="P.O. No:"
        value={transaction.reference}
        stylingMode="outlined"
        labelMode="static"
      />
    </div>,

    <div className="col-md-3" key="recv-ship-dt">
      <TextBox
        disabled={true}
        label="Recv/Ship Dt"
        value={transaction.actualreceivedshippeddatetime
          ? GetDateTimeStandardFormat(transaction.actualreceivedshippeddatetime)
          : ""}
        stylingMode="outlined"
        labelMode="static"
      />
    </div>,

    <div className="col-md-3" key="shipper-bol">
      <TextBox
        disabled={true}
        label="Shipper Bol #"
        value={transaction.shipperbolnumber}
        stylingMode="outlined"
        labelMode="static"
      />
    </div>,

    <div className="col-md-3" key="transaction-group">
      <TextBox
        disabled={true}
        label="Transaction Group"
        value={transaction.transactiongroup}
        stylingMode="outlined"
        labelMode="static"
      />
    </div>
  ];
  // Filter out null or undefined values from the array (when conditions are not met)
  const renderedColumns = columns.filter(Boolean);
  // Break the rendered columns into chunks of 4
  const chunkedColumns = [];
  for (let i = 0; i < renderedColumns.length; i += 4) {
    chunkedColumns.push(renderedColumns.slice(i, i + 4));
  }

  return (
    <>
      {chunkedColumns.map((row, index) => (
        <div className={`row ${index > 0 ? 'accordianLastRow' : ''}`} key={index}>
          {row}
        </div>
      ))}
      <div style={{ display: 'flex', border: '0px solid black', marginTop: '12px' }}>
        <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderTopLeftRadius: '12px', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
          Record #:
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderLeft: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderRight: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          {transaction.recordNumber}
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
          Total Lines:
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderLeft: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderRight: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          {selectedTotals.items}
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
          Ordered:
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderLeft: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderRight: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          {selectedTotals.ordered}
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
          Actual:
        </div>
        <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderTopRightRadius: '12px', borderTop: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderLeft: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), borderRight: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          {selectedTotals.actual}
        </div>
      </div>
      <div style={{ display: 'flex', border: '0px solid black', marginBottom: '12px' }}>
        <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderBottomLeftRadius: '12px', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
          Net Weight:
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          {selectedTotals.netWeight}
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
          Gross Weight:
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          {selectedTotals.grossWeight}
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
          Amount:
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          {selectedTotals.amount}
        </div>
        <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), backgroundColor: window._env_?.Color2 || '#2e7d32', color: 'white', textAlign: 'center' }}>
        </div>
        <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderBottomRightRadius: '12px', border: '1px solid ' + (window._env_?.Color2 || '#2e7d32'), color: 'black', textAlign: 'center' }}>
          &nbsp;
        </div>
      </div>
    </>
  );
};
export default TransactionOverview;